import { apiService } from '../general/APIService';

const ABSTRACT_PRODUCTS_ENDPOINT = 'abstract-products';

export async function getAbstractProducts() {
    const response = await apiService.get(ABSTRACT_PRODUCTS_ENDPOINT);

    return response.data.data;
}
